import { FAQ_ITEMS } from '../seo/businessConfig';

function FaqSection({ title = 'Najczęściej zadawane pytania', className = '' }) {
  return (
    <section
      className={`max-w-4xl mx-auto px-6 md:px-12 ${className}`}
      aria-labelledby="faq-heading"
      itemScope
      itemType="https://schema.org/FAQPage"
    >
      <h2 id="faq-heading" className="text-3xl md:text-5xl font-bold text-primary mb-10 tracking-wide">
        {title}
      </h2>
      <div className="space-y-6">
        {FAQ_ITEMS.map((item, index) => (
          <details
            key={index}
            className="group bg-primary-bright bg-opacity-30 rounded-lg p-5 md:p-6 open:shadow-md transition-shadow"
            itemScope
            itemProp="mainEntity"
            itemType="https://schema.org/Question"
          >
            <summary className="cursor-pointer font-bold text-xl md:text-2xl text-primary list-none flex justify-between items-center gap-4">
              <span itemProp="name">{item.question}</span>
              <span className="text-primary opacity-50 group-open:rotate-45 transition-transform text-3xl leading-none" aria-hidden="true">
                +
              </span>
            </summary>
            <div
              className="mt-4 text-primary text-base md:text-lg leading-relaxed opacity-90"
              itemScope
              itemProp="acceptedAnswer"
              itemType="https://schema.org/Answer"
            >
              <p itemProp="text">{item.answer}</p>
            </div>
          </details>
        ))}
      </div>
    </section>
  );
}

export default FaqSection;
